module.exports = __webpack_public_path__ + "img/04.7c25796f.jpg";